module.exports = __webpack_public_path__ + "img/spinner.9e04b504.gif";